import { motion } from 'framer-motion';
import { painPoints } from '../../../../../data/landingPage/landingPageData';

const PainPointsGrid = () => {
  return (
    <motion.div
      key="problems"
      initial={{ opacity: 0, filter: 'blur(12px)', scale: 0.95, y: 20 }}
      animate={{ opacity: 1, filter: 'blur(0px)', scale: 1, y: 0 }}
      exit={{ opacity: 0, filter: 'blur(12px)', scale: 0.95, y: -20 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 md:gap-8 absolute top-0 left-0 right-0"
    >
      {painPoints.map((point, idx) => (
        <div
          key={idx}
          className="group bg-white border border-gray-100 rounded-2xl sm:rounded-[1.5rem] p-5 sm:p-6 md:p-8 flex flex-col items-center text-center shadow-sm hover:shadow-lg transition-all duration-500 relative overflow-hidden"
        >
          <div
            className={`w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br ${point.bg} flex items-center justify-center mb-4 sm:mb-6 relative z-10 transform group-hover:scale-110 transition-transform duration-500`}
          >
            {point.icon}
          </div>
          <h3 className="text-[#1a2b49] font-semibold text-sm sm:text-base mb-2 sm:mb-3 relative z-10">
            {point.title}
          </h3>
          <p className="text-gray-500 text-xs sm:text-[13px] leading-relaxed relative z-10 font-normal">
            {point.desc}
          </p>
        </div>
      ))}
    </motion.div>
  );
};

export default PainPointsGrid;
